<template>
  <div>
    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
      <!-- <div class="selected"> -->
      <input
        name="label"
        type="text"
        @click="open = !open"
        autocomplete="off"
        id="location"
        @input="search"
        :placeholder="label || $t('inputs.selectInput.selectOption')"
        :class="[open && 'open', error && 'error-border']"
        v-model="searchQuery"
      />
    </div>
    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
      <div
        v-if="!select_obj"
        class="items shadow"
        :class="{ selectHide: !open }"
      >
        <div
          v-for="(option, i) of data.slice(1, data.length)"
          :key="i"
          @click="
            selected = option;
            searchQuery = option;
            open = false;
            $emit('input', option);
          "
        >
          {{ option }}
        </div>
        <div v-if="data.length == 0" class="no-results">{{ $t("inputs.selectInput.noResults") }}</div>
      </div>
      <div v-else class="items shadow" :class="{ selectHide: !open }">
        <div
          v-for="(option, i) of onlyShow
            ? data.slice(0, data.length).filter((item) => {
                return item[onlyShow];
              })
            : data.slice(0, data.length)"
          :key="i"
          @click="
            selected_object = option;
            searchQuery = option[obj_select_key];
            open = false;
            $emit('input', option);
          "
        >
          {{ option[obj_select_key] }}
        </div>
        <div v-if="data.length == 0" class="no-results">{{ $t("inputs.selectInput.noResults") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    select_obj: {
      type: Boolean,
      default: false,
    },
    obj_select_key: {
      type: String,
      default: "title",
    },
    label: {
      type: String,
      default: null,
    },
    show_label_flag: {
      type: Boolean,
      default: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      required: false,
    },
    onlyShow: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options && this.options.length > 0
        ? this.options[0]
        : null,
      open: false,
      data: [],
      selected_object: {},
      searchQuery: "",
    };
  },
  watch: {
    show_label_flag: function () {
      this.show_label = !this.show_label;
      if (this.show_label) {
        this.searchQuery = "";
      }
    },
    options: function () {
      this.data = [];
      this.data = this.options;
    },
    value: function (newValue) {
      console.log("new value from city input: ", newValue);
      if (Object.keys(newValue).length === 0) {
        this.searchQuery = "";
        this.selected_object = {};
      } else if (newValue.title) {
        this.searchQuery = newValue.title;
      } else if (newValue) {
        this.searchQuery = newValue;
      }
    },
  },
  methods: {
    search() {
      this.open = true;
      let arr = [];
      if (this.searchQuery) {
        this.data = this.options;
        this.data.forEach((value) => {
          if (
            value.title
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase())
          )
            arr.push(value);
        });
        this.data = arr;
      } else {
        this.data = this.options;
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
        this.arrowCounter = -1;
      }
    },
  },

  computed: {
    filteredItems() {
      return this.data.filter((item) => {
        return item.title.indexOf(this.searchQuery.toLowerCase()) > -1;
      });
    },
  },
  mounted() {
    this.selected = this.options[0];
    this.show_label = this.show_label_flag;
    document.addEventListener("click", this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    this.data = this.options;
  },
};
</script>

<style lang="scss" scoped>
input {
  max-width: inherit !important;
}
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  float: left;
}

p {
  margin: 0 !important;
}
input {
  width: 100%;
  max-width: none;
  padding: 16px 15px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c1c5d8;
  background-color: #f7f8fa;
  float: left;
  color: #202731;
  &::placeholder {
    color: #788e98;
  }
  &:focus {
    border-color: #202731;
    outline: none;
  }
}

.shadow {
  box-shadow: 0 0 6px rgba(0, 11, 138, 0.12) !important;
}

.custom-select .selected {
  background-color: #f7f8fa;
  width: 100%;
  border-radius: 10px;
  color: #788e98;
  border: 1px solid #c1c5d8;
  cursor: pointer;
  user-select: none;
  padding: 19px 15px;
  float: left;
}

.custom-select .selected span {
  width: max-content;
  float: left;
  font-size: 14px;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 26px;
  right: 15px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #c1c5d8 transparent transparent transparent;
}

.custom-select .items {
  color: #fff;
  border-radius: 10px;
  overflow: auto;
  position: absolute;
  background-color: #ffffff;
  left: 0;
  right: 0;
  top: calc(100% + 8px);
  padding: 10px;
  z-index: 1;
  max-height: 15pc;
}
.custom-select .items::-webkit-scrollbar {
  width: 0.2em;
}
/* Track */
.custom-select .items::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.custom-select .items::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.custom-select .items::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.custom-select .items div {
  color: #fff;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
  padding: 15px 18px;
  color: #2f434c;
  font-size: 16px;
}

.custom-select .items div:not(:last-child) {
  border-bottom: 1px solid #e0e0df;
}

.custom-select .items div:last-child {
  border-radius: 0 0 8px 8px;
}

.custom-select .items div:first-child {
  border-radius: 8px 8px 0 0;
}

.custom-select .items div:hover {
  background-color: #f7f8fa;
}

.custom-select .items .no-results {
  color: #7e939c;
  cursor: default !important;
  &:hover {
    background: white;
  }
}

.selectHide {
  display: none;
}

.error-border {
  border: 1px solid red;
}
</style>
